import React from 'react';
import { createRoot } from 'react-dom/client';

/**
 * Mount a React component tree that manages its own modal chrome (e.g. DS
 * `<Modal>`). The render function receives an `onClose` callback that unmounts
 * the tree and cleans up the DOM container.
 *
 * @returns An object with a `close` method to dismiss programmatically.
 */
export default function renderModal(
  render: (onClose: () => void) => React.ReactNode,
  options?: { afterClose?: () => void },
): { close: () => void } {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = createRoot(container);

  let closed = false;
  const destroy = () => {
    if (closed) return;
    closed = true;
    root.unmount();
    container.remove();
    options?.afterClose?.();
  };

  root.render(<>{render(destroy)}</>);
  return { close: destroy };
}
